import React from 'react';
import { X } from 'lucide-react';

// Shared modal scaffolding. The markup (modal-overlay / modal / modal-header /
// close-btn) is kept exactly as the original inline modals rendered it.
function Modal({ title, onClose, children }) {
  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="close-btn" onClick={onClose}>
            <X size={24} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

export default Modal;
